<template>
    <div class="course-wrap">
        <div v-if="$route.name === 'Wishlist'" class="row">
            <div class="col row">
                <q-btn
                    class="remove full-width"
                    size="md"
                    align="left"
                    icon="close"
                    dense
                    flat
                    @click="removeFromWishlist(course)"
                    >{{ $t('actions.remove_from_wishlist') }}
                </q-btn>
            </div>
            <div class="col-shrink row justify-center">
                <span class="self-center q-px-md">{{
                    formatDate(course.wishlist_date)
                }}</span>
            </div>
        </div>
        <div
            class="course-img"
            :style="'background-image: url(' + courseImage + ')'"
        >
            <router-link
                :to="{
                    name: 'CourseDetails',
                    params: { id: course.id },
                }"
            >
                <div class="overlay" :class="overlayColor(index)">
                    <div
                        v-if="course.courses_coursetype"
                        class="course-type row items-center"
                    >
                        <template
                            v-if="course.courses_coursetype.slug === 'online'"
                        >
                            <q-icon name="language" class="q-mr-sm"></q-icon>
                            {{ $t('general.online') }}
                        </template>
                        <template
                            v-if="
                                course.courses_coursetype.slug === 'presencial'
                            "
                        >
                            <q-icon name="business" class="q-mr-sm"></q-icon>
                            {{ $t('general.presential') }}
                        </template>
                        <template
                            v-if="
                                course.courses_packagetypes &&
                                course.courses_packagetypes.system_slug ===
                                    'pacote'
                            "
                        >
                            <q-icon
                                name="file_copy"
                                class="q-mr-sm q-ml-md"
                            ></q-icon>
                            {{ $t('courses.packaged') }}
                        </template>
                        <div v-if="course.on_promotion" class="promotion">
                            <q-icon name="sell" class="q-mr-sm"> </q-icon>
                            {{
                                course.promotion_discount +
                                '% ' +
                                $t('general.discount')
                            }}
                        </div>
                    </div>
                    <h4 class="course-title">
                        {{ JSONParseTranslations(course.title, locale.key) }}
                    </h4>
                </div>
            </router-link>
        </div>
        <div class="course-summary">
            <p>{{ JSONParseTranslations(course.summary, locale.key) }}</p>
        </div>
        <q-btn
            class="view-btn"
            icon="visibility"
            color="primary"
            text-color="grey-8"
            size="16px"
            flat
            dense
            :to="{
                name: 'CourseDetails',
                params: { id: course.id },
            }"
        >
            <span class="hidden-text">{{ $t('general.see_course') }}</span>
        </q-btn>
        <q-btn
            v-if="course.can_buy"
            class="plus-btn"
            icon-right="add"
            color="primary"
            text-color="grey-8"
            size="16px"
            flat
            dense
            @click="addToCart(course.id)"
        >
            <span class="hidden-text">{{ $t('general.add_to_cart') }}</span>
        </q-btn>
        <q-inner-loading :showing="isLoading">
            <q-spinner-pie color="primary" size="40px" />
        </q-inner-loading>
        <CourseClasses
            :show="classesShow"
            :course="course"
            @hide-classes="hideClasses"
            @added="added"
        />
    </div>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import CourseClasses from '@/components/CourseClasses'
import picturesService from '@/services/pictures'
import coursesService from '@/services/modules/courses'
import formatDate from '@/helpers/date-time'
import encoders from '@/helpers/encoders'
import store from '@/store'

const loadingKeys = {
    fetchingCourse: 'fetching-course',
}

export default {
    name: 'CourseThumb',

    components: {
        CourseClasses,
    },

    mixins: [translate],

    props: {
        index: {
            type: Number,
            default: 0,
        },

        course: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            courseImage: '',
            classesShow: false,
        }
    },

    computed: {
        isLoading() {
            return this.isFetchingCourse
        },

        isFetchingCourse() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingCourse
            ).length
        },

        locale() {
            return store.getters['locale/currentLocale']
        },
    },

    // watch: {
    //     locale: {
    //         handler(newval, oldval) {
    //             console.log(newval, oldval)
    //         },
    //         deep: true,
    //     },
    // },

    async created() {
        if (this.course.coursepicture_id) {
            this.courseImage = await this.fetchImage(
                this.course.coursepicture_id
            )
        } else {
            this.courseImage = require('@/assets/logo.svg')
        }
    },

    methods: {
        overlayColor(index) {
            return 'overlay-color-' + (index % 3)
        },

        showClasses() {
            this.classesShow = true
        },

        hideClasses() {
            this.classesShow = false
        },

        added() {
            this.$emit('added', this.course.id)
            this.classesShow = false
        },

        async addToCart(courseId) {
            this.loadingAdd(loadingKeys.fetchingCourse)

            let parameters = {
                filter: {
                    id: courseId,
                },
                relations: {
                    courses_coursetype: true,
                    courses_packagetypes: true,
                },
            }

            let response = await coursesService.retrieve(parameters)

            if (response.status === 200) {
                if (
                    response.data.results[0].courses_coursetype.slug ===
                    'presencial'
                ) {
                    this.showClasses()
                } else {
                    this.$store.commit(
                        'cart/addItemToCart',
                        response.data.results[0]
                    )
                }
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            }

            this.loadingRemove(loadingKeys.fetchingCourse)
        },

        removeFromWishlist(course) {
            this.$emit('removed', course.id)
        },

        dateMaskFormat() {
            return this.locale &&
                this.locale.definition &&
                this.locale.definition.dateFormat
                ? this.locale.definition.dateFormat
                : 'DD/MM/YYYY'
        },

        formatDate(value) {
            return value
                ? formatDate.fromServerToUxString(
                      value,
                      'date',
                      this.dateMaskFormat()
                  )
                : null
        },

        async fetchImage(pictureId) {
            let imageResponse = await picturesService.retrieveById(pictureId)

            if (imageResponse.status === 200) {
                return encoders.arrayBufferToBase64(imageResponse)
            } else {
                return '' //TODO: add a default image
            }
        },
    },
}
</script>
